import React, {useState, useRef, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { utils, write } from "xlsx";
import Papa from "papaparse";

import { DropDownField, TextInputField, CalendarField } from "../../../helpers";
import Button from "../../../helpers/Button";
import { Menu } from 'primereact/menu';
import { Toast } from 'primereact/toast';

import { fetchOrderHistory, updateSearchParams, updateSearchOptions } from "../../../services/redux/reducers/orderHistory/orderHistory";
import { getAddFilterOptions, getDateRange } from "../../../utils";
import DateFilter from "../../../common/DateFilter";


const orderHistorySearchConfig = [
    {
        srNO: 1,
        static: true,
        type: "SELECT",
        name: "dataType",
        label: "Data type",
        options: [
            { label: 'OrderHistory Data', value: 'orderHistoryData' }
        ]
    },
    {
        srNO: 2,
        static: true,
        type: "SEARCH_BY",
        name: "searchBy",
        label: "Search by",
        options: [
            { label: 'No Filters', value: 'all' },
            { label: 'Invoice No', value: 'invoiceNo' },
            { label: 'Doc No', value: 'docNo'}
            //{ label: 'Product Name/Specification', value: 'productNameSpec' },
            // { label: 'Company Name', value: 'companyName' },
            // { label: 'KAM Name', value: 'kamName' },
        ]
    },
    {
        srNO: 3,
        static: false,
        type: "DATE",
        name: "dateType",
        label: "Date",
        options: [
            { label: 'Created Date', value: 'createdAt' },
        ]
    },
]

const Search = (props) => {
    const dispatch = useDispatch()
    const [searchConfig, setSearchConfig] = useState(orderHistorySearchConfig)

    const paginationParams = useSelector(state => state.orderHistory.paginationParams)
    const searchParams = useSelector(state => state.orderHistory.searchParams)
    const searchOptions = useSelector(state => state.orderHistory.searchOptions)

    const filterMenu = useRef(null)

    useEffect(()=> {
        if(searchOptions.length === 0){
            const filteredSearchOptions = searchConfig.filter(eachOption => eachOption.static)
            dispatch(updateSearchOptions(filteredSearchOptions))
        }
    }, [])

    const addFilterOption = (srNO) => {
        const relatedConfig = searchConfig.find(eachConfig => eachConfig.srNO === srNO)
        dispatch(updateSearchOptions([...searchOptions, relatedConfig]))
    }

    const removeFilterOption = (srNO) => {
        const relatedSearchOption = searchOptions.find(eachOption => eachOption.srNO === srNO)
        const updatedSearchParams = {...searchParams}

        if(relatedSearchOption.type === "SEARCH_BY"){
            updatedSearchParams.searchText = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if(relatedSearchOption.type === "DATE"){
            updatedSearchParams.fromDate = null
            updatedSearchParams.toDate = null
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if(relatedSearchOption.type === "SELECT"){
            updatedSearchParams[relatedSearchOption.name] = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if (relatedSearchOption.type === "MULTISELECT") {
            updatedSearchParams[relatedSearchOption.name] = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }

        const filteredSearchOptions = searchOptions.filter(eachOption => eachOption.srNO !== srNO)
        dispatch(updateSearchOptions([...filteredSearchOptions]))
    }

    const handleSearchOnChange = (event) => {
        let eventValue = event.target.value
        const updatedSearchParams = {...searchParams, [event.target.name]: event.target.value}

        if (eventValue instanceof Date) {
            if(new Date(searchParams[event.target.name])?.getTime() != eventValue.getTime()){
                updatedSearchParams.range = null
            }

            if (event.target.name === "toDate") {
                eventValue.setHours(23, 59, 0, 0)
            }
            if (event.target.name === "fromDate") {
                eventValue.setHours(0, 0, 0, 0)
            }
            eventValue = eventValue.toISOString()

            updatedSearchParams[event.target.name] = eventValue
        }

        dispatch(updateSearchParams(updatedSearchParams))
    }

    const handleDateRangeChange = (range) => {
        const { fromDate, toDate } = getDateRange(range)
        getDateRange(range)
        dispatch(updateSearchParams({ ...searchParams, range, fromDate, toDate }))
    }

    const addFilterOptions = getAddFilterOptions(searchConfig, searchOptions, searchParams, addFilterOption)

    const handleSearchKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSearch()
        }
    } 

    const handleSearch = () => {
        if(!searchParams.searchBy){
            return Toast.current.show({ severity: 'warn', summary: 'Warn Message', detail: "Please enter search by", life: 3000 })
        }
        if(!searchParams.searchText && searchParams.searchBy != 'all'){
            return Toast.current.show({ severity: 'warn', summary: 'Warn Message', detail: "Please enter search text", life: 3000 })
        }
        
        dispatch(fetchOrderHistory({ ...paginationParams, ...searchParams, pageNo: 0 }))
    }

    return(
        <div className="p-card" style={{border:"1px solid #e9ecef"}} onKeyDown={handleSearchKeyPress}>
            <Toast ref={Toast} />
            <div className="grid"> 
                {
                    searchOptions.map(eachOption => {
                        if(eachOption.type === "SEARCH_BY"){
                            return (
                                <>  
                                    { !eachOption.static ? 
                                        <div className="flex justify-content-end p-0 col-12 remove-opt">
                                            <i className="pi pi-minus-circle remove-opt-icon" onClick={()=> removeFilterOption(eachOption.srNO)}></i>
                                        </div>
                                        :
                                        null 
                                    }
                                    <div className="flex flex-column col-12">
                                        <DropDownField name="searchBy" labelText="Search By" options={eachOption.options} value={searchParams["searchBy"]} onChange={handleSearchOnChange} />
                                    </div>
                                    { searchParams.searchBy !== "all" ?
                                        <div className="flex flex-column col-12">
                                            <TextInputField name="searchText" labelText="Search Text" value={searchParams["searchText"]} onChange={handleSearchOnChange} />
                                        </div> : null
                                    }
                                </>
                            )
                        }
                        if(eachOption.type === "DATE"){
                            return (
                                <>  
                                    <DateFilter 
                                        eachOption={eachOption} 
                                        searchParams={searchParams} 
                                        dateOptions={["MTD", "PM", "L15", "L30"]}
                                        handleDateRangeChange={handleDateRangeChange} 
                                        handleSearchOnChange={handleSearchOnChange}
                                        removeFilterOption={removeFilterOption}
                                    />
                                </>
                            )
                        }
                        if(eachOption.type === "SELECT"){
                            return (
                                <>
                                    { !eachOption.static ? 
                                        <div className="flex justify-content-end p-0 col-12 remove-opt">
                                            <i className="pi pi-minus-circle remove-opt-icon" onClick={()=> removeFilterOption(eachOption.srNO)} ></i>
                                        </div>
                                        :
                                        null 
                                    }
                                    <div className="flex flex-column col-12">
                                        <DropDownField name={eachOption.name} options={eachOption.options} labelText={eachOption.label} value={searchParams[eachOption.name]} onChange={handleSearchOnChange} />
                                    </div>
                                </>
                            )
                        }
                    })
                }
                <div className="flex col-12 justify-content-end">
                    <Menu model={addFilterOptions} popup ref={filterMenu} />
                    <Button icon="pi pi-filter" className="h-2rem p-2 action-btn hover:surface-300 hover:text-700" label="Add Filter" onClick={(e) => filterMenu.current.toggle(e)} />
                </div>

                <div className="flex flex-column col-12 mb-0 pb-0">
                    <div className="grid">
                        <div className="flex col-12 mb-0 gap-1 pb-0">
                            <Button label="Search" style={{flexGrow: 1}} className="py-2" onClick={handleSearch} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Search;